import "./Error.html";
import "./Error.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { ErrorComponentController } from "./ErrorComponentController";

export class ErrorComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            error: "=ngModel",
        };
        this.controller = ErrorComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Indicators/Error/Error.html";
    }
}
